import { Box, styled } from '@mui/material';
import { CSSProperties } from 'react';

export const VideoBackground = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  overflow: 'hidden',
});

export const iframeStyles: CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '100vw',
  height: '56.25vw',
  minWidth: '177.78vh',
  minHeight: '100vh',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
  border: 0,
};
